import RegionsContainer from "../../container/admin/regions";

const RegionsView = () => {
    return <RegionsContainer />;
};

export default RegionsView;
